import { component } from 'picoapp';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const daysCount = node.querySelector('.js-daysCount');
  const hoursCount = node.querySelector('.js-hoursCount');
  const minutesCount = node.querySelector('.js-minutesCount');
  const secondsCount = node.querySelector('.js-secondsCount');

  const config = JSON.parse(node.dataset.config);

  /**
   * Functions
   */
  const initCounter = () => {
    const { currentDateSource, targetDateSource } = config;

    const createDateFromSource = (source) => {
      const [year, month, day, hours, minutes, seconds] = source.split('/');
      return new Date(year, month - 1, day, hours, minutes, seconds);
    };

    const currentDate = createDateFromSource(currentDateSource);
    const targetDate = createDateFromSource(targetDateSource);

    const oneDay = 1000 * 60 * 60 * 24;
    const oneHour = 1000 * 60 * 60;
    const oneMinute = 1000 * 60;
    const oneSecond = 1000;

    let interval;

    /* eslint-disable */
    const update = () => {
      currentDate.setSeconds(currentDate.getSeconds() + 1);

      let timeDiff = targetDate.getTime() - currentDate.getTime();

      if (timeDiff < 0) {
        return clearInterval(interval);
      }

      const daysDiff = Math.floor(timeDiff / oneDay);
      timeDiff -= daysDiff * oneDay;

      const hoursDiff = Math.floor(timeDiff / oneHour);
      timeDiff -= hoursDiff * oneHour;

      const minutesDiff = Math.floor(timeDiff / oneMinute);
      timeDiff -= minutesDiff * oneMinute;

      const secondsDiff = Math.floor(timeDiff / oneSecond);

      daysCount.textContent = daysDiff;
      hoursCount.textContent = hoursDiff;
      minutesCount.textContent = minutesDiff;
      secondsCount.textContent = secondsDiff;
    };
    /* eslint-enable */

    interval = setInterval(update, 1000);
  };

  const init = () => {
    if (config.showCounter) {
      initCounter();
    }
  };

  /**
   * Init
   */
  init();
});
